import template from './switchFilter.html';

function SwitchFilterController() {
  this.toggle = () => {
    const newValue = !this.filter.value;
    this.filter.changeValue(newValue);
  };
}

const switchFilter = {
  template,
  bindings: {
    filter: '<',
    label: '@'
  },
  controller: SwitchFilterController
};

export default function (ngModule) {
  ngModule.component('switchFilter', switchFilter);
}
